var _toConsumableArray = require("/codebuild/output/src538327727/src/actions-runner/_work/www-lwb-org-au/www-lwb-org-au/node_modules/@babel/runtime/helpers/toConsumableArray.js");
var _defineProperty = require("/codebuild/output/src538327727/src/actions-runner/_work/www-lwb-org-au/www-lwb-org-au/node_modules/@babel/runtime/helpers/defineProperty.js");
Object.defineProperty(exports, Symbol.toStringTag, {
  value: 'Module'
});
var currentScopes = require('../currentScopes.js');
var debugBuild = require('../debug-build.js');
var integration = require('../integration.js');
var semanticAttributes = require('../semanticAttributes.js');
var console = require('../utils-hoist/instrument/console.js');
var logger = require('../utils-hoist/logger.js');
var string = require('../utils-hoist/string.js');
var worldwide = require('../utils-hoist/worldwide.js');
var exports$1 = require('./exports.js');
var INTEGRATION_NAME = 'ConsoleLogs';
var DEFAULT_ATTRIBUTES = _defineProperty({}, semanticAttributes.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN, 'auto.console.logging');
var _consoleLoggingIntegration = function _consoleLoggingIntegration() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var levels = options.levels || logger.CONSOLE_LEVELS;
  return {
    name: INTEGRATION_NAME,
    setup: function setup(client) {
      var _client$getOptions$_e;
      if (!((_client$getOptions$_e = client.getOptions()._experiments) !== null && _client$getOptions$_e !== void 0 && _client$getOptions$_e.enableLogs)) {
        debugBuild.DEBUG_BUILD && logger.logger.warn('`_experiments.enableLogs` is not enabled, ConsoleLogs integration disabled');
        return;
      }
      console.addConsoleInstrumentationHandler(function (_ref) {
        var args = _ref.args,
          level = _ref.level;
        if (currentScopes.getClient() !== client || !levels.includes(level)) {
          return;
        }
        if (level === 'assert') {
          if (!args[0]) {
            var followingArgs = args.slice(1);
            var message = followingArgs.length > 0 ? "Assertion failed: ".concat(formatConsoleArgs(followingArgs)) : 'Assertion failed';
            exports$1._INTERNAL_captureLog({
              level: 'error',
              message: message,
              attributes: DEFAULT_ATTRIBUTES
            });
          }
          return;
        }
        var isLevelLog = level === 'log';
        exports$1._INTERNAL_captureLog({
          level: isLevelLog ? 'info' : level,
          message: formatConsoleArgs(args),
          severityNumber: isLevelLog ? 10 : undefined,
          attributes: DEFAULT_ATTRIBUTES
        });
      });
    }
  };
};

/**
 * Captures calls to the `console` API as logs in Sentry. Requires `_experiments.enableLogs` to be enabled.
 *
 * @experimental This feature is experimental and may be changed or removed in future versions.
 *
 * By default the integration instruments `console.debug`, `console.info`, `console.warn`, `console.error`,
 * `console.log`, `console.trace`, and `console.assert`. You can use the `levels` option to customize which
 * levels are captured.
 *
 * @example
 *
 * ```ts
 * import * as Sentry from '@sentry/browser';
 *
 * Sentry.init({
 *   integrations: [Sentry.consoleLoggingIntegration({ levels: ['error', 'warn'] })],
 * });
 * ```
 */
var consoleLoggingIntegration = integration.defineIntegration(_consoleLoggingIntegration);
function formatConsoleArgs(values) {
  var _worldwide$GLOBAL_OBJ;
  return 'util' in worldwide.GLOBAL_OBJ && typeof worldwide.GLOBAL_OBJ.util.format === 'function' ? (_worldwide$GLOBAL_OBJ = worldwide.GLOBAL_OBJ.util).format.apply(_worldwide$GLOBAL_OBJ, _toConsumableArray(values)) : string.safeJoin(values, ' ');
}
exports.consoleLoggingIntegration = consoleLoggingIntegration;